import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { ChanagePasswordComponent } from './chanage-password.component';

const routes: Routes = [{ path: '', component: ChanagePasswordComponent }];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class ChanagePasswordRoutingModule { }
